import { markerUnitEntityName } from '@features/analysesSection/markerUnit/service/constants'
import { markerEntityName } from '@features/analysesSection/markers/service/constants'
import createEntityChangementConfig2 from '@infrastructure/entityChangement/createEntityChangementConfig2'
import { getEntityChangementMessage } from '@infrastructure/entityChangement/utils'
import queryClient from '@infrastructure/reactQuery/queryClient'
import toast from '@infrastructure/toast/toast'

import formulaRQKeys from '../reactQuery/formulaRQKeys'
import formulaHelpers from '../service/formulaHelpers'

export default createEntityChangementConfig2({
  entity: formulaHelpers.entityName,
  config: [
    {
      changements: ['created', 'updated', 'deleted'],
      listener: ({ name, type }) => {
        toast.info({
          title: getEntityChangementMessage(name, type)
        })
        const key = formulaRQKeys.lists()
        queryClient.invalidateQueries(key)
      }
    },
    {
      changements: ['updated'],
      listener: ({ meta: { id } }) => {
        const key = formulaRQKeys.detail(id)
        queryClient.invalidateQueries(key)
      }
    },
    {
      changements: ['deleted'],
      listener: ({ meta: { id } }) => {
        const key = formulaRQKeys.detail(id)
        queryClient.removeQueries(key)
      }
    }
  ],
  dependenciesConfig: [
    {
      entities: [markerEntityName, markerUnitEntityName],
      changements: ['created', 'updated', 'deleted'],
      listener: () => {
        const key = formulaRQKeys.formData()
        queryClient.invalidateQueries(key)
      }
    }
  ]
})
